/**
 * App Settings Reducers
 */
import {
    BOXED_LAYOUT,
    CHANGE_AGENCY_LAYOUT_BG,
    CHANGE_THEME_COLOR,
    CHANGE_USER_TOUR_STEP,
    COLLAPSED_SIDEBAR,
    DARK_MODE,
    MINI_SIDEBAR,
    RTL_LAYOUT,
    SEARCH_FORM_ENABLE,
    SET_CONTACT_US_DIALOG_MESSAGE,
    SET_LANGUAGE,
    SET_SIDEBAR_IMAGE,
    SET_USER_TOUR_AUTO_START,
    START_USER_TOUR,
    STOP_USER_TOUR,
    TOGGLE_DARK_SIDENAV,
    TOGGLE_DEFAULT_TEMPLATE_DIALOG_OPEN,
    TOGGLE_SIDEBAR_IMAGE,
} from '../actions/types';
// app config
import AppConfig from '../config/AppConfig';

/**
 * initial app settings
 */
const INIT_STATE = {
    navCollapsed: AppConfig.navCollapsed,
    darkMode: AppConfig.darkMode,
    boxLayout: AppConfig.boxLayout,
    rtlLayout: AppConfig.rtlLayout,
    miniSidebar: AppConfig.miniSidebar,
    searchFormOpen: false, // search form by default false
    userTour: {
        runUserTour: false,
        currentTourStep: 0,
        autoStart: true,
    },
    uploadNewDocumentsIsShown: false,
    isDarkSidenav: AppConfig.isDarkSidenav,
    enableThemeOptions: AppConfig.enableThemeOptions,
    themes: [
        {
            id: 1,
            name: 'primary',
        },
        {
            id: 2,
            name: 'secondary',
        },
        {
            id: 3,
            name: 'warning',
        },
        {
            id: 4,
            name: 'info',
        },
        {
            id: 5,
            name: 'danger',
        },
        {
            id: 6,
            name: 'success',
        },
    ],
    activeTheme: {
        id: 1,
        name: 'primary',
    },
    // sidebar background image
    sidebarBackgroundImages: [
        require('../assets/img/sidebar-1.jpg'),
    ],
    enableSidebarBackgroundImage: AppConfig.enableSidebarBackgroundImage, // default enable sidebar background
    selectedSidebarImage: AppConfig.sidebarImage, // default sidebar background image
    locale: AppConfig.locale,
    needToShowDefaultTemplateDialog: false,
    languages: [
        {
            languageId: 'english',
            locale: 'en',
            name: 'English',
            icon: 'en',
        },
        // {
        //     languageId: 'chinese',
        //     locale: 'zh',
        //     name: 'Chinese',
        //     icon: 'zh',
        // },
        // {
        //     languageId: 'russian',
        //     locale: 'ru',
        //     name: 'Russian',
        //     icon: 'ru',
        // },
        // {
        //     languageId: 'hebrew',
        //     locale: 'he',
        //     name: 'Hebrew',
        //     icon: 'he',
        // },
        // {
        //     languageId: 'french',
        //     locale: 'fr',
        //     name: 'French',
        //     icon: 'fr',
        // },
        // {
        //     languageId: 'saudi-arabia',
        //     locale: 'ar',
        //     name: 'Arabic',
        //     icon: 'ar',
        // },
        // {
        //     languageId: 'german',
        //     locale: 'de',
        //     name: 'German',
        //     icon: 'de',
        // },
        // {
        //     languageId: 'spanish',
        //     locale: 'es',
        //     name: 'Spanish',
        //     icon: 'es',
        // },
        // {
        //     languageId: 'japanese',
        //     locale: 'ja',
        //     name: 'Japanese',
        //     icon: 'ja',
        // },
        // {
        //     languageId: 'korean',
        //     locale: 'ko',
        //     name: 'Korean',
        //     icon: 'ko',
        // },
        // {
        //     languageId: 'italian',
        //     locale: 'it',
        //     name: 'Italian',
        //     icon: 'it',
        // },
        // {
        //     languageId: 'hungarian',
        //     locale: 'hu',
        //     name: 'Hungarian',
        //     icon: 'hu',
        // }
    ],
    agencyLayoutBgColors: [
        {
            id: 1,
            class: 'bg-grdnt-violet',
            active: true,
        },
        {
            id: 2,
            class: 'bg-grdnt-youtube',
        },
        {
            id: 3,
            class: 'bg-grdnt-primary-danger',
        },
        {
            id: 4,
            class: 'bg-grdnt-purple-danger',
        },
        {
            id: 5,
            class: 'bg-grdnt-purple-dark',
        },
    ],
    contactUsDialogMessage: '',
    highlighter: {
        lastFocusedField: {}
    },
};

export default (state = INIT_STATE, action) => {
    switch (action.type) {
        // collapse sidebar
        case COLLAPSED_SIDEBAR:
            return {...state, navCollapsed: action.isCollapsed};

        // start user tour
        case START_USER_TOUR:
            const currentUserTour = _.get(state, 'userTour');
            _.set(state, 'userTour', {...currentUserTour, runUserTour: true, currentTourStep: action.payload});
            return state;

        // stop user tour
        case STOP_USER_TOUR:
            _.set(state, 'userTour.runUserTour', false);
            return state;

        case CHANGE_USER_TOUR_STEP:
            _.set(state, 'userTour.currentTourStep', action.payload);
            return state;

        case SET_USER_TOUR_AUTO_START:
            _.set(state, 'userTour.autoStart', action.payload);
            return state;

        // change theme color
        case CHANGE_THEME_COLOR:
            return {...state, activeTheme: action.payload};

        // dark mode
        case DARK_MODE:
            return {...state, darkMode: action.payload};

        // boxed layout
        case BOXED_LAYOUT:
            return {...state, boxLayout: action.payload};

        // rtl layout
        case RTL_LAYOUT:
            return {...state, rtlLayout: action.payload};

        // mini sidebar
        case MINI_SIDEBAR:
            return {...state, miniSidebar: action.payload};

        // search form
        case SEARCH_FORM_ENABLE:
            document.body.classList.toggle('search-active', !state.searchFormOpen);
            return {...state, searchFormOpen: !state.searchFormOpen};

        // togglw sidebar image
        case TOGGLE_SIDEBAR_IMAGE:
            return {...state, enableSidebarBackgroundImage: !state.enableSidebarBackgroundImage};

        // set sidebar image
        case SET_SIDEBAR_IMAGE:
            return {...state, selectedSidebarImage: action.payload};

        // set language
        case SET_LANGUAGE:
            return {...state, locale: action.payload};

        // dark sidenav
        case TOGGLE_DARK_SIDENAV:
            return {...state, isDarkSidenav: !state.isDarkSidenav};

        // agency layout bg handler
        case CHANGE_AGENCY_LAYOUT_BG:
            const layoutsBg = [];
            for (const layoutBg of state.agencyLayoutBgColors) {
                if (layoutBg.id === action.payload.id) {
                    layoutBg.active = true;
                } else {
                    layoutBg.active = false;
                }
                layoutsBg.push(layoutBg);
            }
            return {
                ...state,
                agencyLayoutBgColors: layoutsBg,
            };
        case SET_CONTACT_US_DIALOG_MESSAGE:
            return {...state, contactUsDialogMessage: action.payload};
        case TOGGLE_DEFAULT_TEMPLATE_DIALOG_OPEN:
            return {...state, needToShowDefaultTemplateDialog: action.payload};
        default:
            return {...state};
    }
};
